import accruent from "./accruent.png";
import baptist_health_south_florida from "./baptist_health_south_florida.png";
import coffee_bean_and_tea_leaf from "./coffee_bean_and_tea_leaf.png";
import Corrigo from "./Corrigo.png";
import dsl from "./dsl.svg";
import dslnwLogoSmall4 from "./dslnw-logo-small4.jpg";
import jll from "./jll.png";
import service_master from "./service_master.png";
import taylor from "./taylor.png";
import tfg_mobile from "./tfg_mobile.png";
import Wawa from "./Wawa.png";
import wayfair from "./wayfair.png";

export default {
  Wawa,
  wayfair,
  accruent,
  dslnwLogoSmall4,
  service_master,
  baptist_health_south_florida,
  coffee_bean_and_tea_leaf,
  dsl,
  tfg_mobile,
  Corrigo,
  jll,
};



// WEBPACK FOOTER //
// ./src/assets/commercial_logos/assets.js